import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router, NavigationStart  } from '@angular/router';
import { SharedService } from '../../shared/services/shared.service';
@Component({
  selector: 'app-doc-viewer-dialog',
  templateUrl: './doc-viewer-dialog.component.html',
  styleUrls: ['./doc-viewer-dialog.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class DocViewerDialogComponent implements OnInit {
  fileUrl = "";
  loader = true;
  title = "";
  fileName: any;
  viewer = 'google';
  isShowViewer = false;
  isShowImg = false;
  documentFileName: any;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private router: Router, public sharedService:SharedService) {       
    // var isTokenAvailable = this.sharedService.isTokenAvailable();
       
    // if(isTokenAvailable){
    // setInterval(() =>  this.checkSessionTimeout(), 10000);
    // }
  }

  ngOnInit(): void {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('VMS');
        if(token == undefined) { 
           this.ref.close(); 
        }
   }
    });
    this.loader = true;
    if (this.config.data && this.config.data.title && this.config.data.fileName) {
      this.fileUrl = this.config.data.fileUrl;
      this.title = this.config.data.title;
      this.fileName = this.config.data.fileName;
      this.documentFileName = this.config.data.documentFileName;
      if(this.fileUrl.split('.').pop() == 'xls' || this.fileUrl.split('.').pop() == 'xlsx'){
        this.viewer = 'office';
        this.isShowViewer = true;
      }else if (this.fileUrl.split('.').pop() == 'gif' || this.fileUrl.split('.').pop() == 'bmp' || this.fileUrl.split('.').pop() == 'png' || this.fileUrl.split('.').pop() == 'jpeg' || this.fileUrl.split('.').pop() == 'jpg'){
        this.isShowImg = true;
      }
      else if(this.fileName.split('.').pop() == 'gif' || this.fileName.split('.').pop() == 'bmp' || this.fileName.split('.').pop() == 'png' || this.fileName.split('.').pop() == 'jpeg' || this.fileName.split('.').pop() == 'jpg'){
        this.isShowImg = true;
      }
        else{
        this.viewer = 'google';
        this.isShowViewer = true;
      }
      if(this.documentFileName != undefined){
        if(this.documentFileName.split('.').pop() == 'xls' || this.documentFileName.split('.').pop() == 'xlsx'){
        this.viewer = 'office';
        this.isShowViewer = true;
      }
      else if (this.documentFileName.split('.').pop() == 'gif' || this.documentFileName.split('.').pop() == 'bmp' || this.documentFileName.split('.').pop() == 'png' || this.documentFileName.split('.').pop() == 'jpeg' || this.documentFileName.split('.').pop() == 'jpg'){
        this.isShowImg = true;
      }
      else{
        this.viewer = 'google';
        this.isShowViewer = true;
      }
    }
      // else{
      //   this.viewer = 'google';
      //   this.isShowViewer = true;
      // }
    }
    else{
      this.ref.close(null);
      alert("some required data is missing")
    }
    setTimeout(() => {
      this.ref.close();
    }, 180000);

    
  }
 
  loaded(e:any){
    if(this.viewer == 'office'){
      setTimeout(() => {
        this.loader = false;
      }, 3000)
    }else{
      this.loader = false;
    }
  }

  imageLoad(e:any){
    this.loader = false;
  }

  close(){
    this.ref.close();
  }
  checkSessionTimeout()
  {

    var isTokenAvailable = this.sharedService.isTokenAvailable();
    console.log('Session I' + isTokenAvailable);
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
      
       if(!result) {
         //localStorage.removeItem('VMS');
        // localStorage.clear();
        this.ref.close();
        this.router.navigate(['/login'])
      .then(() => {
    window.location.reload();
  });
       }
    } 
   
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.ref.close(); 
  }
}
